import { render, staticRenderFns } from "./WizardSidebar.vue?vue&type=template&id=e40d993c&scoped=true&"
import script from "./WizardSidebar.vue?vue&type=script&lang=js&"
export * from "./WizardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WizardSidebar.vue?vue&type=style&index=0&id=e40d993c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40d993c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
